import React, { FC, useState } from "react";
import clsx from "clsx";
import { Button } from "@material-ui/core";
import styles from "./components.module.scss";
import FullscreenModal from "components/FullscreenModal";
import RadioButton from 'components/RadioButton/RadioButton';


interface ChooseBioProps {
    isOpen: boolean;
    spellCheckedResponse: string;
    enhancedResponse: string;
    onBack: () => void;
    onSave: (about: string) => void;
    setRemoveContactInfoModal: (removeContactInfoModal: boolean) => void;
    removeContactInfoModal: boolean;
    rewritesLeft: number;
}

export const ChooseBio: FC<ChooseBioProps> = ({
    isOpen,
    spellCheckedResponse,
    enhancedResponse,
    onBack,
    onSave,
    rewritesLeft
}) => {

    const responses = {
        spellChecked: spellCheckedResponse,
        enhanced: enhancedResponse
    };

    const [selected, setSelected] = useState<string | null>(null);
    
    const handleClick = (selectedItem: string) => {
        setSelected(selectedItem);
    };
    
    return (
        <FullscreenModal
            title="About You"
            isOpen={isOpen}
            onClose={onBack}
            onSubmit={() => console.log('Submit')}
            isSignUpPage={true}
        >
            <div className={styles.contentContainer}>
                <div className={styles.helpText}>
                    <header className={clsx(styles.header, styles.headerSpace)}>
                            <h1>We've got two options, <b>select the one you prefer to continue.</b></h1>
                            <p><b>Not loving either? </b><a className={styles.backLink} onClick={onBack}>Go back and edit your original</a></p>
                    </header>

                    <div className={styles.minimal}>
                        <div className={styles.bioRadioGroup}>
                        <RadioButton 
                                isActive={selected === "0"}
                                handleClick={() => handleClick("0")}
                                item={"0"}
                            />
                            <div className={styles.helpText__version}>
                                Minimal Version
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.responseText}>{spellCheckedResponse}</p>
                        </div>
                    </div>

                    <div className={styles.extraFlair}>
                        <div className={styles.bioRadioGroup}>
                        <RadioButton 
                                isActive={selected === "1"}
                                handleClick={() => handleClick("1")}
                                item={"1"}
                            />
                            <div className={styles.helpText__version}>
                                Extra Flair
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.responseText}>{enhancedResponse}</p>
                        </div>
                    </div>
                    <div className={styles.helpText__rewrites}>
                            <p>Remaining re-writes: {rewritesLeft}/5</p>
                    </div>
                </div>
                <div>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => {
                            if (selected) {
                                onSave(selected === "0" ? responses.spellChecked : responses.enhanced);
                            }
                            onBack();
                        }}
                        className={clsx("bigButtonInNewStyle")}
                    >
                        Continue
                    </Button>                
                </div>
                <p className={styles.reportText}>
                    This is a new feature we’re trying - please 
                    <a href={`mailto:feature-feedback@tempstars.com`} 
                    className="external externalLink"
                    target="_system"
                    > report any problems or feedback here
                    </a> so we can make any necessary improvements.
                </p>
            </div>
        </FullscreenModal>
    );
}